import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { addMember } from "../member/ApiMember";
import { applyClassToCharacters } from "../../constants/const";

const MemberAddressPreview = ({
  memberId,
  totalAmount,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [hasAddress, setHasAddress] = useState(false);
  const cacheRef = useRef({});

  const shouldFetch = Boolean(
    memberId &&
    Number(memberId) > 0 &&
    Number(totalAmount) >= 5000
  );

  useEffect(() => {
    if (!shouldFetch) {
      setAddress("");
      setHasAddress(false);
      setLoading(false);
      return;
    }

    const mid = Number(memberId);
    if (cacheRef.current[mid] !== undefined) {
      const cached = cacheRef.current[mid];
      setAddress(cached.address);
      setHasAddress(cached.hasAddress);
      setLoading(false);
      return;
    }

    let isMounted = true;
    setLoading(true);

    addMember()
      .getMemberAddress(mid)
      .then((res) => {
        if (!isMounted) return;
        const addr = res.data?.address ? String(res.data.address).trim() : "";
        const exists = Boolean(res.data?.hasAddress && addr);
        cacheRef.current[mid] = { address: addr, hasAddress: exists };
        setAddress(addr);
        setHasAddress(exists);
        setLoading(false);
      })
      .catch(() => {
        if (!isMounted) return;
        cacheRef.current[mid] = { address: "", hasAddress: false };
        setAddress("");
        setHasAddress(false);
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [memberId, shouldFetch]);

  if (!shouldFetch) {
    return null;
  }

  if (loading) {
    return (
      <div
        className="d-flex align-items-center mb-2 text-muted"
        style={{ fontSize: "12px", padding: "4px 0" }}
      >
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        />
        <span>{t("common_loading") || "Loading..."}</span>
      </div>
    );
  }

  if (hasAddress) {
    return (
      <div
        className="member-address-preview-box mb-2 p-2 rounded"
        style={{
          background: "#f8f9fa",
          border: "1px solid #e7eaec",
          fontSize: "13px",
          lineHeight: "1.6",
        }}
      >
        <div className="mb-1 text-muted" style={{ fontWeight: "600", fontSize: "12px" }}>
          <i className="fa fa-map-marker text-success" style={{ marginRight: "6px" }}></i>
          {t("registered_member_address")}
        </div>
        <div
          style={{
            color: "#2f4050",
            wordBreak: "break-word",
            userSelect: "text",
            cursor: "text",
          }}
        >
          {applyClassToCharacters(address, "ur")}
        </div>
      </div>
    );
  }

  return (
    <div
      className="text-muted mb-2"
      style={{
        fontSize: "12px",
        lineHeight: "1.4",
      }}
    >
      <i className="fa fa-info-circle text-warning" style={{ marginRight: "5px" }}></i>
      {t("no_registered_address_found")}
    </div>
  );
};

export default MemberAddressPreview;
